module.exports = __webpack_public_path__ + "img/module6.765b9a59.png";